import React, {useRef} from "react";
import PreviewImg from "../atoms/PreviewImg";
import PreviewTitle from "../atoms/PreviewTitle";
import {useSelector} from "react-redux";
import usePartOptionController from "./usePartOptionController";
import {Scrollbars} from "react-custom-scrollbars-2";
import PartSelector from "../molecules/PartSelector";

const PartOptionDetail = ({
                            partArray,
                            code,
                            title,
                            stepObject,
                            personalItemObject,
                          }) => {
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const scrollbarsRef = useRef();


  const {findSelectedPartItem, fetchedPartGroups, processedParts, isLoading} = usePartOptionController(partArray, stepObject);

  const codeKeyData = sendData[code];
  const findSelectedData = findSelectedPartItem(stepObject, codeKeyData, personalItemObject);
  const { selectedItem, selectedIndex} = findSelectedData;

  return (
    <div className={"option-h3"} data-expand={true} data-value={!!sendData[code]}>
      <div className={"option-value part-option-value"}>
        <PreviewImg selectedItem={selectedItem} type={"PART"}/>
        <PreviewTitle selectedItem={selectedItem} title={title} type={"PART"}/>
      </div>
      <Scrollbars ref={scrollbarsRef} autoHide>
        <PartSelector
          partArray={partArray}
          code={code}
          codeKeyData={codeKeyData}
          stepObject={stepObject}
          selectedIndex={selectedIndex}
          personalItemObject={personalItemObject}
          fetchedPartGroups={fetchedPartGroups}
          processedParts={processedParts}
          isLoading={isLoading}
        />
      </Scrollbars>
    </div>
  );
}

export default PartOptionDetail;
